var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEContracts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2841_23455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 3H3V41H41V3Z",
    fill: "url(#paint0_linear_2841_23455)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M31.1113 18.5102V19.5951H35.5735C35.7564 19.8968 36.0886 20.0998 36.4688 20.0998C37.0471 20.0998 37.5163 19.6315 37.5163 19.0532C37.5163 18.4748 37.0471 18.0056 36.4688 18.0056C36.0886 18.0056 35.7564 18.2086 35.5735 18.5102H31.1113Z",
    fill: "url(#paint1_linear_2841_23455)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M37.7471 21.2258C37.3679 21.2258 37.0347 21.4279 36.8518 21.7314H34.726L34.569 22.0024L33.5933 24.3809H31.1104V25.4658H32.3733H33.9045H34.2157L34.3727 25.1948L35.3484 22.8163H36.8518C37.0347 23.1179 37.3679 23.3209 37.7471 23.3209C38.3254 23.3209 38.7956 22.8517 38.7956 22.2734C38.7956 21.695 38.3254 21.2268 37.7471 21.2268V21.2258Z",
    fill: "url(#paint2_linear_2841_23455)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M32.3824 20.6197H31.7705V21.7046H32.3824C32.5653 22.0062 32.8975 22.2092 33.2777 22.2092C33.857 22.2092 34.3252 21.74 34.3252 21.1617C34.3252 20.5833 33.857 20.1151 33.2777 20.1151C32.8975 20.1151 32.5662 20.3171 32.3824 20.6207V20.6197Z",
    fill: "url(#paint3_linear_2841_23455)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M37.1955 26.5258C36.8154 26.5258 36.4841 26.7279 36.2993 27.0304H31.1104V28.1153H36.2993C36.4831 28.4179 36.8154 28.62 37.1955 28.62C37.7729 28.62 38.2421 28.1517 38.2421 27.5724C38.2421 26.9941 37.7729 26.5258 37.1955 26.5258Z",
    fill: "url(#paint4_linear_2841_23455)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.98139 25.4275L10.1384 25.6985H15.291V24.6136H10.7608L9.38772 22.2351L9.23068 21.9641H7.10494C6.92205 21.6615 6.58883 21.4585 6.20964 21.4585C5.63129 21.4585 5.16113 21.9277 5.16113 22.5051C5.16113 23.0825 5.63129 23.5526 6.20964 23.5526C6.58883 23.5526 6.92205 23.3496 7.10494 23.048H8.60828L9.98139 25.4265V25.4275Z",
    fill: "#440A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9084 20.5546C10.3291 20.5546 9.86084 21.0238 9.86084 21.6012C9.86084 22.1786 10.3291 22.6487 10.9084 22.6487C11.2885 22.6487 11.6198 22.4457 11.8037 22.1441H12.88V21.0592H11.8037C11.6208 20.7566 11.2885 20.5536 10.9084 20.5536V20.5546Z",
    fill: "#440A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2909 28.349V27.2641H9.24021C9.05637 26.9625 8.7241 26.7595 8.34396 26.7595C7.76656 26.7595 7.29736 27.2287 7.29736 27.8061C7.29736 28.3834 7.76656 28.8536 8.34396 28.8536C8.7241 28.8536 9.05541 28.6516 9.24021 28.349H14.0001V31.031H17.1112V29.7403H15.2909V28.349Z",
    fill: "#440A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.07196 20.3592C9.45211 20.3592 9.78437 20.1572 9.96726 19.8546H15.2912V18.7697H9.96726C9.78437 18.4671 9.45211 18.2651 9.07196 18.2651C8.49361 18.2651 8.02441 18.7343 8.02441 19.3127C8.02441 19.891 8.49361 20.3592 9.07196 20.3592Z",
    fill: "#440A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6363 15.8339L25.5176 12.7142C25.5176 12.7142 25.5119 12.7104 25.509 12.7104H12.9058C12.609 12.7104 12.3687 12.9517 12.3687 13.2486L12.383 32.7747C12.383 33.7246 13.1538 34.4945 14.1047 34.4945H28.0618C28.4802 34.4945 28.8221 34.1517 28.8221 33.7342V16.283C28.8221 16.1078 28.7598 15.9574 28.6363 15.8339Z",
    fill: "#440A16"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.7923 11.9942L28.6143 8.8161C28.485 8.68684 28.3107 8.61502 28.1288 8.61502H14.7673C14.4455 8.61502 14.1851 8.87547 14.186 9.19721L14.2042 31.9876C14.2042 32.3659 14.5126 32.6751 14.8917 32.6751H31.3069C31.6851 32.6751 31.9944 32.3659 31.9944 31.9876V12.4806C31.9944 12.291 31.9274 12.1282 31.7933 11.9942H31.7923Z",
    fill: "url(#paint5_linear_2841_23455)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7923 11.9942L28.6143 8.8161C28.485 8.68684 28.3107 8.61502 28.1288 8.61502H14.7673C14.4455 8.61502 14.1851 8.87547 14.186 9.19721V9.59842C14.188 9.2786 14.4474 9.02006 14.7673 9.02006H27.8894C28.0713 9.02006 28.2466 9.09283 28.3749 9.22114L31.553 12.3992C31.687 12.5333 31.8756 12.8541 31.9934 13.1155V12.4816C31.9934 12.292 31.9264 12.1292 31.7923 11.9951V11.9942Z",
    fill: "#ECCFDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5337 22.1087H26.1935L26.8475 20.274C26.9183 20.0768 26.8705 19.8374 26.7259 19.7072C26.5813 19.5559 26.3658 19.5003 26.1657 19.5626L23.1121 20.5086C23.1744 20.0031 23.206 19.4936 23.206 18.9842V18.8033C23.206 17.5862 22.2187 16.599 21.0017 16.599C19.7847 16.599 18.7974 17.5862 18.7974 18.8033V19.7215C18.7974 20.027 19.0435 20.2731 19.349 20.2731C19.6544 20.2731 19.9005 20.027 19.9005 19.7215V18.7822C19.9005 18.1943 20.3946 17.6801 21.0027 17.6801C21.6107 17.6801 22.1048 18.1943 22.1048 18.7822V18.9842C22.1048 19.6153 22.0521 20.2472 21.9439 20.8486L19.4668 21.629C18.6404 21.8904 18.064 22.6736 18.064 23.5603V25.2781C18.064 26.1667 18.7831 26.8859 19.6506 26.8859C20.2357 26.8859 20.7575 26.59 21.0285 26.1055L21.4115 25.4993C22.0933 24.3647 22.5663 23.1275 22.8746 21.8367L22.8976 21.7285L25.4418 20.9405L24.8931 22.4745C24.8338 22.644 24.8587 22.8307 24.9621 22.9772C25.0655 23.1237 25.2331 23.2118 25.4121 23.2118H28.5347C28.8401 23.2118 29.0862 22.9657 29.0862 22.6602C29.0862 22.3548 28.8401 22.1087 28.5347 22.1087H28.5337ZM20.4674 24.9306L20.1026 25.5367C20.0106 25.6698 19.8479 25.7828 19.6506 25.7828C19.3911 25.7828 19.1661 25.5577 19.1661 25.2772V23.5594C19.1661 23.1572 19.4275 22.8019 19.8134 22.6612L21.671 22.1058C21.402 23.0978 20.996 24.0487 20.4674 24.9306Z",
    fill: "url(#paint6_linear_2841_23455)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5293 25.349C22.695 25.0158 22.8462 24.672 22.9822 24.3244H28.6173C28.8759 24.3244 29.0837 24.5533 29.0837 24.8367C29.0837 25.1201 28.8759 25.349 28.6173 25.349H22.5293Z",
    fill: "url(#paint7_linear_2841_23455)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7921 11.9942L28.614 8.8161C28.4848 8.68684 28.3105 8.61502 28.1286 8.61502H27.8901V12.6491C27.8901 12.8062 28.0175 12.9326 28.1736 12.9326H31.9942V12.4806C31.9942 12.291 31.9271 12.1282 31.7931 11.9942H31.7921Z",
    fill: "url(#paint8_linear_2841_23455)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M28.1738 12.9326C28.8345 12.9354 31.9944 12.9326 31.9944 12.9326V15.245C31.9944 15.245 31.7397 14.2387 30.8952 13.6584C30.1464 13.1442 29.4445 13.0695 28.1738 12.9335V12.9326Z",
    fill: "url(#paint9_linear_2841_23455)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2841_23455",
    x1: 22.0005,
    y1: 41.0996,
    x2: 22.0005,
    y2: 16.5684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D11934"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2841_23455",
    x1: 35.4327,
    y1: 17.1199,
    x2: 26.0842,
    y2: 32.2395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F5ECF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9C7D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2841_23455",
    x1: 37.1706,
    y1: 19.8881,
    x2: 28.052,
    y2: 34.6362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F5ECF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9C7D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2841_23455",
    x1: 35.457,
    y1: 17.1438,
    x2: 26.7769,
    y2: 31.1814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F5ECF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9C7D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2841_23455",
    x1: 38.7238,
    y1: 20.9051,
    x2: 29.2422,
    y2: 36.2391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F5ECF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9C7D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2841_23455",
    x1: 14.186,
    y1: 20.6446,
    x2: 31.9934,
    y2: 20.6446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F5ECF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9C7D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2841_23455",
    x1: 18.063,
    y1: 21.741,
    x2: 29.0843,
    y2: 21.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D11934"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2841_23455",
    x1: 22.5293,
    y1: 24.8367,
    x2: 28.5436,
    y2: 24.8367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D11934"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2841_23455",
    x1: 24.5569,
    y1: 16.013,
    x2: 30.8011,
    y2: 9.93643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F7A7B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB2244"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2841_23455",
    x1: 28.4333,
    y1: 15.0574,
    x2: 30.3666,
    y2: 13.9217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA1934"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2841_23455"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 38,
    height: 38,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEContracts);
export default __webpack_public_path__ + "static/media/e-contracts.95dbee7c705625c75f3f1ffc683c6bf0.svg";
export { ForwardRef as ReactComponent };